/**
 * Personal config. Edit these values to match your physiology.
 * Changes take effect on the next dev/build — no code changes needed.
 */

export const config = {
  /**
   * Heart-rate zones as explicit bpm ranges.
   * Set to `null` to hide HR zones in the detail view.
   *
   * Bounds are inclusive. Any HR below Z1.lower is counted in Z1;
   * any HR above the last zone's upper is counted in the top zone.
   */
  hrZones: [
    { label: 'Recovery', lower: 115, upper: 142 },
    { label: 'Aerobic', lower: 143, upper: 155 },
    { label: 'Tempo', lower: 156, upper: 168 },
    { label: 'Threshold', lower: 169, upper: 182 },
    { label: 'VO2 Max', lower: 183, upper: 195 }
  ] as HrZoneConfig[] | null,

  /** Distance unit shown throughout the UI. */
  distanceUnit: 'mi' as 'mi' | 'km'
};

export interface HrZoneConfig {
  label: string;
  lower: number;
  upper: number;
}
